import { MutationResolvers } from '@spazious/dollhouse-graphql';
import { migrateGraph } from '@spazious/dollhouse-shallow-graph';

import { ApolloContext } from '../context.js';
import { getFurnitureStats } from '../helpers/index.js';

/**
 * Resolver for the updateGraph mutation.
 */
export const updateGraph: MutationResolvers<ApolloContext>['updateGraph'] = async (
  _,
  { graph: graphInput, id },
  context
) => {
  const { api } = context;
  const result = await api.diagramming.partialUpdateDiagrammingVirtualMeetingRoomSetupsId({
    id,
    partialUpdateDiagrammingVirtualMeetingRoomSetupsIdRequest: {
      data: {
        id: id,
        type: 'VirtualMeetingRoomSetup',
        attributes: {
          graph: JSON.stringify(graphInput),
          name: graphInput.name,
          furnitures: getFurnitureStats(context.graph),
        },
        relationships: {
          virtualMeetingRoom: {
            data: {
              type: 'VirtualMeetingRoom',
              id: `${graphInput.space}`,
            },
          },
        },
      },
    },
  });

  const data = result.data.data;
  const parsedGraph = migrateGraph(JSON.parse(data.attributes?.graph ?? 'null'));

  return {
    id: data.attributes?.uuid!,
    ...parsedGraph,
    cursor: parsedGraph.cursor ?? null,
    name: parsedGraph.name!,
  };
};
